export const USER_COOKIE = "ueniUser";
export const ACCEPTED_COOKIES = "hasAcceptedCookies";
export const REDIRECT_COOKIE = "ueni_login_redirect";
